// const button = document.querySelector('button.btn.green');
// const form = document.querySelector('form.wpcf7-form');

/* funciona, porém atualiza a página quando clica */
// button.addEventListener('click', function(event) {
  
//   if (form.checkValidity()) {
//   button.disabled = true;
//   form.submit()
//   }
// });



(function($) {
  
    /* FORMULÁRIO */
    const form = jQuery('form.wpcf7-form');
    const button = jQuery('button.btn.green');
    
    form.on('submit', function(){
      button.attr('disabled', true);
    });
  
      $('.wpcf7').on('wpcf7submit', function(){
      button.attr('disabled', false);
    });
    /* MENU MOBILE */
    
    jQuery('.mobile-menu-button').on('click',function() {
        jQuery(this).toggleClass('open');
        jQuery('.mobile-menu').toggleClass('open');
        jQuery('body').toggleClass('no-scroll');
    });
    
    /* SUPORTE */
    
    jQuery('.support button').on('click', function(e) {
        $(this).parent().toggleClass('show');
    });
    
    /* CARROSSEL */
    
    let tablet = 1090;
    let smartphone = 700;
    let small = 550;
    
    $('.front-page .solucoes-wle .carrossel').slick({
      centerMode: true,
      dots: false,
      infinite: true,
      initialSlide: 0,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      prevArrow:"<button class='a-left control-c prev slick-prev'></button>",
      nextArrow:"<button class='a-right control-c next slick-next'></button>",
      responsive: [
        {
          breakpoint: tablet,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: smartphone,
          settings: {
            centerMode: false,
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: small,
          settings: {
            centerMode: false,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
    
    $('.front-page .clientes .carrossel').slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      prevArrow:"<button class='a-left control-c prev slick-prev'></button>",
      nextArrow:"<button class='a-right control-c next slick-next'></button>",
      responsive: [
        {
          breakpoint: tablet,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: smartphone,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: small,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
    
    $('.front-page .depoimentos .carrossel').slick({
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 2,
      slidesToScroll: 1,
      adaptiveHeight: true,
      arrows: false,
      responsive: [
        {
          breakpoint: smartphone,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
    
    $('.page-institucional .clientes .carrossel').slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      prevArrow:"<button class='a-left control-c prev slick-prev'></button>",
      nextArrow:"<button class='a-right control-c next slick-next'></button>",
      responsive: [
        {
          breakpoint: tablet,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: smartphone,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: small,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
    
    /* MÓDULO SOLUÇÕES */
    const solucoes = $('.modulo-solucoes .slider-container')
    
    if(solucoes.length) {
      solucoes.each(function() {
        
        $(this).find('.slider-wrapper').slick({
          mobileFirst: true,
          arrows: false,
          infinite: false,
          slidesToShow: 1,
          dots: true,
          appendDots: $(this),
          prevArrow: $(this).find('.prev'),
          nextArrow: $(this).find('.next'),
          responsive: [
            {
              breakpoint: 550,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 700,
              settings: {
                slidesToShow: 3,
                dots: false,
                arrows: true,
              }
            },
            {
              breakpoint: 1090,
              settings: {
                slidesToShow: 5,
                dots: false,
                arrows: true,
              }
            },
          ]
        })
        
      })
    }
    
    /* INTEGRAÇÕES  */
    
    let integracoes = $('.front-page .integracoes .carrossel');
    
    let integracoesSlider = function(event) {
      if (window.matchMedia("(max-width: 1000px)").matches) {
        if (!integracoes.hasClass("slick-slider")) {
          integracoes.slick({
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: true,
            prevArrow:"<button class='a-left control-c prev slick-prev'></button>",
            nextArrow:"<button class='a-right control-c next slick-next'></button>",
            responsive: [
              {
                breakpoint: tablet,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 1,
                }
              },
              {
                breakpoint: smartphone,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 2
                }
              },
              {
                breakpoint: small,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
              // You can unslick at a given breakpoint now by adding:
              // settings: "unslick"
              // instead of a settings object
            ]
          });
        }
      } else {
        if (integracoes.hasClass("slick-slider")) {
          integracoes.slick('unslick'); 
        }
      }
    }
    
    window.onresize = integracoesSlider;
    window.onload = integracoesSlider;
  
    /* SLIDER DE PLANOS MOBILE */
    $(document).ready(function() {
      if ($(".front-page").length) {
        const table = $(".table");
        
        if (table.length) {
          const plans = $(".plans");
          const colPlanos = plans.find(".col");
          const colRecursos = $(".resources .col");
          const recursos = colRecursos.children();
          const linhas = $(".table .data")
          
          const leftArrow = $(".arrows .left-arrow");
          const rightArrow = $(".arrows .right-arrow");
          
          function getResourceWidth() {
              return colRecursos.parent().outerWidth();
          }
          
          function updateDataSize() {
          
              recursos.each(function () {
          
                  let recurso = $(this);
                  let indexRecurso = recurso.index();
          
                  if (recurso.hasClass("closed")) {
                      recursoHeight =  recurso.children().first().outerHeight();
                  } else {
                      recursoHeight =  recurso.prop('scrollHeight');
                  }
          
                  recurso.css("max-height", recursoHeight+"px");
                  let linhasRecursos = recurso.children();
          
                  colPlanos.each(function () {
                  
                      let col = $(this);
                      let windowWidth = $(window).width();
                      let plansWidth = plans.width();
          
                      if (windowWidth < small) {
                          col.width((plansWidth)+"px");
                      } else if (windowWidth < tablet) {
                          col.width((plansWidth/2)+"px");
                      } else if (windowWidth >= tablet) {
                          col.width("unset");
                      } 
          
                      let recursosDoPlano = $(this).find(".data");
                      recursosDoPlano.each(function () {
              
                          let recursoDoPlano = $(this);
                          let indexRecursoDoPlano = recursoDoPlano.index() - 1; // do not count the header
          
                          if (indexRecurso == indexRecursoDoPlano) {
                              recursoDoPlano.css("max-height", recursoHeight+"px");
          
                              let linhasPlanos = recursoDoPlano.children();
                          
                              linhasPlanos.each(function ( index ) {
                                  $(this).innerHeight( linhasRecursos.eq(index).innerHeight() );
                              });
                          }
                          
                          
                      });
                  });
              });
          
              scroll();
          }
          
          function closeAllData() {
              
              recursos.each(function () {
          
                  let recurso = $(this);
                  let newRecursoHeight = recurso.children().first().outerHeight();
          
                  recurso.css("max-height", newRecursoHeight+"px");
                  recurso.addClass("closed");
          
                  colPlanos.each(function () {
          
                      let recursosDoPlano = $(this).find(".data");
                      
                      recursosDoPlano.each(function () {
              
                          $(this).css("max-height", newRecursoHeight+"px");
          
                      });
                  });
              });
          
          }
          
          function collapseData() {
            
              let index = $(this).parents(".resources").length ? $(this).index() : $(this).index() - 1;
              
              let recurso = recursos.eq( index );
              let newRecursoHeight;
          
              if (recurso.hasClass("closed")) {
                  newRecursoHeight =  recurso.prop('scrollHeight');
              } else {
                  newRecursoHeight =  recurso.children().first().outerHeight();
              }
          
              recurso.css("max-height", newRecursoHeight+"px");
          
              colPlanos.each(function () {
          
                  let recursosDoPlano = $(this).find(".data");
                  let recursoAtual = recursosDoPlano.eq(index);
          
                  recursoAtual.css("max-height", newRecursoHeight+"px");
              });
          
              recurso.toggleClass("opened");
              recurso.toggleClass("closed");
              
          }
          
          function scroll(event) {
              let eventDirection = event ? event.data.direction : null;
              let containerPosition = table.offset().left + getResourceWidth();
              let closer;
              let newScroll = 0;
          
              /* Esse foreach serve para definir a *
              *  coluna de plano que está na visão *
              *  do usuário no momento             */
              colPlanos.each(function () {
                  let plan = $(this);
                  let planPosition = containerPosition - plan.offset().left;
                  let closerPosition = containerPosition - (closer != null ? closer.offset().left : 0);
          
                  if (Math.abs(planPosition) < Math.abs(closerPosition) || closer == null) {
                      closerProximity = planPosition;
                      closer = plan;
                  }
              });
          
              
              /* Esse foreach serve para pegar a soma do       *
              *  tamanho das colunas anteriores ou posteriores */ 
          
              if (eventDirection == "right") {
          
                  if (closer.next().length) {
                      closer = closer.next();
                  }
          
              } else if (eventDirection == "left") {
          
                  if (closer.prev().length) {
                      closer = closer.prev();
                  }
                  
              } 
              
              closer.prevAll().each(function() {
                  newScroll += $(this).width();
              });
          
              if (event) {
                  plans.animate({scrollLeft: newScroll}, 100);
              } else {
                  plans.scrollLeft(newScroll);
              }
          }
          
          
              setTimeout(function() {
                  updateDataSize();
                  closeAllData();
              }, 50);
          
          linhas.on("click", collapseData);
          leftArrow.on("click",  {direction: "left"}, scroll);
          rightArrow.on("click", {direction: "right"}, scroll);
          
          $(window).resize(updateDataSize);
        }
      }
    });
    
    
    /* BOTÃO SUBMIT */
    // $("button[data-type='submit']").on("click", function() {
    //   $(this).parents("form").submit();
    // });
    
    /* MAPA */
    
    let widthScreen = $(window).width();
    
    if ($("#map").length) {
      const features = [
        new ol.Feature({
          geometry: new ol.geom.Point([-50.15372, -25.11871]),
          name: 'WLE - Matriz',
        }),
        new ol.Feature({
          geometry: new ol.geom.Point([-49.80726, -26.11818]),
          name: 'WLE - Filial 1',
        }),
        new ol.Feature({
          geometry: new ol.geom.Point([-51.08889, -26.2229]),
          name: 'WLE - Filial 2',
        })
      ];
      
      const map = new ol.Map({
        target: 'map',
        interactions: ol.interaction.defaults({dragPan: widthScreen > smartphone ? true : false, mouseWheelZoom: widthScreen > smartphone ? true : false}).extend([
          new ol.interaction.DragPan({
            condition: function (event) {
              return this.getPointerCount() === 2 || ol.events.condition.platformModifierKeyOnly(event);
            },
          }),
          new ol.interaction.MouseWheelZoom({
            condition: ol.events.condition.platformModifierKeyOnly,
          }),
        ]),
        layers: [
          new ol.layer.Tile({
            className: 'bw',
            source: new ol.source.OSM(),
          }),
          new ol.layer.Vector({
            source: new ol.source.Vector({
              className: 'icons',
              features: features 
            }),
            style: new ol.style.Style({
              image: new ol.style.Icon({
                anchor: [0.5, 200],
                anchorXUnits: 'fraction',
                anchorYUnits: 'pixels',
                scale: 0.3,
                src: $("#map").data("markers")
              })
            })
          }),
        ],
        view: new ol.View({
          projection: 'EPSG:4326',
          center: [-50.448081050000006, -25.60710302150409],
          zoom: widthScreen > smartphone ? 9 : 7,
          minZoom: 7
        })
      });
    }
    
    /* Curriculo do formulário */

    $("form .curriculos>div:first-of-type").on("click", function() {
      $("form .curriculos input").click();
      event.stopPropagation();
    });
    
    /* Menu retrátil */
    
    $(window).scroll(function (event) {
      let limitePx = 50;
      let scroll = $(window).scrollTop();
      let retract = $("header.header");
      
      if (scroll >= limitePx && !retract.hasClass("retract")) {
        retract.addClass("retract");
      }
      
      if (scroll < limitePx && retract.hasClass("retract")) {
        retract.removeClass("retract");
      }
      
    });
    
    
    /* --------------------------------------------- */
    
    $(".reply").on("click", function() {
      let comment = $(this).parents(".comment");
      
      comment.find(".response-form").addClass("show");
      comment.find("#comment_parent").val( comment.data("parent") ? comment.data("parent") : comment.attr("id") );
      comment.find("#author").focus();
    });
    
    
    /* Whatsapp button */
    
    let whatsapp_button = jQuery('.whatsapp-popup');
    
    $(document).ready(function() {
      whatsapp_button.addClass("loaded");
    });
    
    
    /* TRABALHE CONOSCO */
    
    $('.page-trabalhe-conosco input[name="curriculo"]').on('change', function() {
      $('.curriculo-mensagem').html('Currículo anexado.');
    });
    
    
    
})(jQuery);
(function($) {
    
    // CF7 events
	const cf7 = document.querySelectorAll('.wpcf7 form')
	
	if(cf7) {
		cf7.forEach(form => {
			form.addEventListener('submit', function() {
				const button = this.querySelector('button[type=submit]')
				
				button.setAttribute('disabled', true)
				button.classList.add('loading')
			})
		
			form.addEventListener('wpcf7submit', function() {
				const button = this.querySelector('button[type=submit]')
				
				button.removeAttribute('disabled')
				button.classList.remove('loading')
			})
		})
	}
	
    // Mask phone input
    let phoneMaskFunction = function(val) {
    	return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
    }
    
    $('input[type="tel"]').mask(phoneMaskFunction, {
    	onKeyPress: function(val, e, field, options) {
    		field.mask(phoneMaskFunction.apply({}, arguments), options);
    	}
    });
    
    // Mask CNPJ input
	let cnpjMaskFunction = function(val) {
	    return '00.000.000/0000-00';
	}
	
	$('input[name="cnpj"]').mask(cnpjMaskFunction, {
	    onKeyPress: function(val, e, field, options) {
	        field.mask(cnpjMaskFunction.apply({}, arguments), options);
	    }
	});
	
    // Mask date inputs
    $('input.custom-date').mask('00/00/0000')
    
})(jQuery);